import {
  Attribute, ChangeDetectorRef,
  Component, inject,
  Injector,
  Optional, SkipSelf, ViewChild, ViewContainerRef
} from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FilterPipe, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler, getFieldLayoutConfig, APPLY_STYLES_TYPE } from "@wm/components-base";
import { includes, some, get, filter, forEach, find, isEmpty, extend } from 'lodash-es';
import { FormFieldDirective } from "./form-field/form-field.directive";
import { extendProto, DynamicComponentRefProvider, getVariableName, runtimeEventManager } from "@wm/core";
import { LiveFilterDirective } from "./live-filter.directive";
import { setListClass } from '../../formWidgetUtils';

const WIDGET_CONFIG: IWidgetConfig = { widgetType: 'wm-form', hostClass: 'panel app-panel app-form' };
const LOGIN_FORM_CONFIG = { widgetType: 'wm-form', hostClass: 'app-form app-login-form' };
const LIVE_FORM_CONFIG = { widgetType: 'wm-liveform', hostClass: 'panel app-panel app-liveform liveform-inline' };
const LIVE_FILTER_CONFIG = { widgetType: 'wm-livefilter', hostClass: 'panel app-panel app-livefilter clearfix liveform-inline' };

const getWidgetConfig = (isLiveForm: any, isLiveFilter: any, role: any) => {
  let config = WIDGET_CONFIG;
  if (isLiveForm !== null) {
    config = LIVE_FORM_CONFIG;
  } else if (isLiveFilter !== null) {
    config = LIVE_FILTER_CONFIG;
  } else if (role === 'app-login') {
    config = LOGIN_FORM_CONFIG;
  }
  return config;
};
let prepareElements: Function;
@Component({
  selector: '[wmForm]',
  template: `<div class="panel-heading" *ngIf="!isLayoutDialog && (title || subheading || iconclass)">
    <h3 class="panel-title">
      <div class="pull-left"><i class="app-icon panel-icon {{iconclass}}" ngShow="iconclass"></i></div>
      <div class="pull-left">
        <div class="heading">{{title}}</div>
        <div class="description">{{subheading}}</div>
      </div>
      <div class="form-action panel-actions basic-btn-grp">
      </div>
    </h3>
  </div>
  <div [hidden]="!isLayoutDialog" class="text-left"><i class="wi wi-gear app-dialogmode-icon"></i><span class="app-dialogmode-text">Live form in dialog mode</span></div>
  <div class="form-body panel-body" [class.hidden]="isLayoutDialog" [ngClass]="{'form-elements': isLayoutDialog, 'form-body': !isLayoutDialog}" apply-styles="inner-shell">
    <div [ngClass]="{'form-elements': !isLayoutDialog, 'form-content': isLayoutDialog}" wmsTransclude>
      <ng-content></ng-content>
      <div class="overlay" *ngIf="showNoFieldsMsg">
        <span>MESSAGE_CANNOT_GENERATE_FIELDS_IN_STUDIO</span>
      </div>
    </div>
    <div class="basic-btn-grp form-action panel-footer clearfix" [class.hidden]="!(isLiveform ? (!isLayoutDialog && showBtns) : this.showBtns)">
    </div>
  </div>
  <ng-template #buttonRef let-btn>
    <button name="{{btn.key}}" [attr.data-evaluated-caption]="btn.displayName.startsWith('bind:')" [attr.disabled]="btn.disabled.toString() === 'true' ? true : null" class="btn app-button {{btn.class}}" [hidden]="!((updateMode ? btn.updateMode : !btn.updateMode) && btn.show.toString() === 'true')">
    <i class="app-icon {{btn.iconclass}}"></i>
    <span class="btn-caption">{{btn.displayName.startsWith('bind:') ? btn.name : btn.displayName}}</span>
    </button>
  </ng-template>
  <ng-template #anchorRef let-btn>
    <a name="{{btn.key}}" [attr.disabled]="btn.disabled.toString() === 'true' ? true : null" class="app-anchor {{btn.class}}" [hidden]="!((updateMode ? btn.updateMode : !btn.updateMode) &&btn.show.toString() === 'true')">
    <i class="app-icon {{btn.iconclass}}"></i>
    <span class="anchor-caption">{{btn.displayName.startsWith('bind:') ? btn.name : btn.displayName}}</span>
    </a>
  </ng-template>
  <div hidden class="hidden-elements">
    <ng-container #dynamicForm></ng-container>
    </div>
  <div hidden class="hidden-actions">
    <ng-container #dynamicFormAction></ng-container>
  </div>`,
  providers: [
    provideAsWidgetRef(FormComponent)
  ],
  exportAs: 'wmForm',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FilterPipe],
  styles: []
})
export class FormComponent extends StylableComponent {
  static initializeProps = register('wm-form');
  public showBtns: any;
  public title: string;
  public name: string;
  public subheading: string;
  public iconclass: string;
  public showNoFieldsMsg: boolean;
  public formFields: Array<FormFieldDirective> = [];
  formfields: { [key: string]: FormFieldDirective } = {};
  formWidgets: { [key: string]: FormFieldDirective } = {};
  filterWidgets: { [key: string]: LiveFilterDirective } = {};
  _captionClass = '';
  _widgetClass = '';
  captionwidth: string;
  captionposition: any;
  ngform: FormGroup;
  buttonArray: any[] = [];
  _liveTableParent: any;
  isLayoutDialog: any;
  prevDataValues: any;
  updateMode: boolean;
  private fb: FormBuilder;
  formlayout: string;
  isSelected: boolean;
  isLiveform: boolean = false;
  isLivefilter: boolean = false;
  datasource: any;
  captionAlignClass: string;
  captionsize: any;
  variableType: any;
  private dynamicComponentProvider: DynamicComponentRefProvider;
  clearFilter: Function;
  applyFilter: Function;
  filter: Function;
  filterOnDefault: Function;
  onMaxDefaultValueChange: Function;
  binddataset: any;
  variableService: any;
  enctype: any;
  private markupManager: any;
  private parentNode: HTMLElement;
  public itemsPerRowClass: string
  @ViewChild('dynamicForm', { static: true, read: ViewContainerRef }) dynamicFormRef: ViewContainerRef;
  @ViewChild('dynamicFormAction', { static: true, read: ViewContainerRef }) dynamicFormActionRef: ViewContainerRef;

  constructor(inj: Injector,
    @Optional() viewParent: Parent,
    @Attribute('wmLiveForm') isLiveForm: any,
    @Attribute('wmLiveFilter') isLiveFilter: any,
    @Attribute('data-role') role: any,
    private cdr: ChangeDetectorRef,
    @Attribute('defaultmode') private defaultmode?: string,
    @SkipSelf() @Optional() public parentForm?: FormComponent) {
    super(inj, getWidgetConfig(isLiveForm, isLiveFilter, role), viewParent);
    this.fb = inject(FormBuilder);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER, ['height']);
    this.variableService = runtimeEventManager.getService('variableService');
    this.ngform = this.fb.group({});
    this.dynamicComponentProvider = runtimeEventManager.getService('dynamicComponentRefProvider');
    prepareElements = runtimeEventManager.getService('componentRefProvider').prepareElements;
    let eventName = 'compile-form-fields' + this.widgetId;
    runtimeEventManager.off(eventName);
    runtimeEventManager.on(eventName).subscribe((obj: any) => {
      let markup = obj.markup;
      let cp = obj.props.find((prop: any) => prop.key === 'captionposition');
      if (cp) {
        this.setLayoutConfig(cp.value);
        this.$element.attr('captionposition', cp.value);
        this.captionposition = cp.value;
      }
      this.compileFormFields(markup);
    });
  }

  override ngAfterViewInit(): void {
    let variableName = getVariableName(this);
    let variable = this.variableService.getVariableByName(variableName, this);
    if (variable && variable.category !== 'wm.Variable' && this.widgetProps['enctype']) {
      this.widgetProps['enctype']?.options && this.widgetProps['enctype'].options.push('');
      this.widgetProps['enctype'].disabled = true;
      this.enctype = '';
    }
  }

   compileFormFields(markup: string) {
    let eventName = this.widgetId + 'prepare-elements';
    let markupObj, fieldsObj: JQuery<HTMLElement>, actionsObj: JQuery<HTMLElement>;
    //as multiple form directives will be listening to the event, apply field-definitions only for current form
    if (!markup) {
      return;
    }
    this.formFields = [];
    this.buttonArray = [];
    this.$element.find('.form-elements').empty();
    // this.$element.find('.basic-btn-grp').empty();
    if (this.widgetType === 'wm-livefilter') {
      markupObj = $('<div>' + markup + '</div>');
      fieldsObj = markupObj.find('> :not(wm-filter-action)'); // select nodes other than form-actions
      actionsObj = markupObj.find('> wm-filter-action');
    } else {
      markupObj = $('<div>' + markup + '</div>');
      fieldsObj = markupObj.find('> :not(wm-form-action)'); // select nodes other than form-actions
      actionsObj = markupObj.find('> wm-form-action');

    }// select form-action nodes
    /* if layout grid template found, simulate canvas dom addition of the elements */
    if (fieldsObj) {
      prepareElements(fieldsObj);
    } else {
      /* else compile and add the form fields */
      if (this.widgetType === 'wm-livefilter') {
        fieldsObj = markupObj.find('wm-filter-field');
      } else {
        fieldsObj = markupObj.find('wm-form-field');
      }
    }
    const $el = this.$element;
     const parentNode = this.parentNode;
     $el.find('.form-elements').append(fieldsObj);

    // Fixes: create new proj and add db. Dnd liveform in page and db to hrdb and click on adv setting
     // Try to modify the widget type from text to textarea or nothing, we see only for firsttime form view is disturbed
     // if u reopen adv settings, all the fields previously checked are unchecked.
     // On reload or next time dnd it works fine without issues.
     // Observation: This was occuring bcoz lifecycle hooks of those inner formfields was not triggered and hence resulting in this issue.
     // Next time it works bcoz it works like aot, as markup is updated it loaded properly from next time.
     // GoogleSearch: changeDetection has to be trigger as we are doing dom manipulations here. But that did not help.
     // Other:  Instead of manually manipulating the DOM, consider using Angular's ViewContainerRef to dynamically add components
     // we are using global viewContainerRef for this but in form and table it didnt work well.
     // Hence tried with viewContainerRef inside the component itself and tried to use it and it worked.
     // TODO: we can instead try to use the same global ViewContainerRef
    let randomNum = Math.random();
     this.dynamicComponentProvider.getComponentFactoryRef('wm-form-component-'+ randomNum, ($el[0].outerHTML).toString(), {
       noCache: true,
       transpile: true,
       viewContainerRef: this.dynamicFormRef
     }).then((componentFactoryRef: any) => {
       let context = (this.dynamicComponentProvider as any).getContext();
       extend(componentFactoryRef.instance, context);
       extendProto(componentFactoryRef.instance, context);

       const $childEl = $(parentNode).find('[widget-id="' + this.widgetId + '"]').first();
       const dynamicEl = this.$element.find('.hidden-elements').find('[widget-id="' + this.widgetId + '"]');
       const cloneEl = dynamicEl;
       parentNode.insertBefore(cloneEl[0], $childEl[0]);
       // this.dynamicFormRef.clear();
       $childEl[0].remove();
       cloneEl[0].widget = this;
       let formfields = $(dynamicEl).find('[wmformfield]');
       forEach(formfields, (el) => {
         (el as any).widget.form = this
       });
       setTimeout(() => {
         cloneEl.trigger('click');
         runtimeEventManager.emit('reset-active-canvas-el');
         this.getMarkupManager()?.setActiveCanvasEl(cloneEl);
         $childEl[0].remove();
         $(parentNode).find('.wm-focus-rect').remove();
         runtimeEventManager.emit('set-active-widget', this.widgetId);

         cloneEl.find('.basic-btn-grp.form-action').empty();
         let actionsDiv = $('<div></div>').append(actionsObj);
         this.dynamicComponentProvider.getComponentFactoryRef('wm-form-action-' + randomNum, (actionsDiv[0].outerHTML).toString(), {
           noCache: true,
           transpile: true,
           viewContainerRef: this.dynamicFormActionRef
         }).then(() => {
           let el = this.$element.find('.hidden-actions');
           let actionsEl = el.find('[wmformaction]');
             const actualFormEl = $(cloneEl).filter('[wmform]');
             const actualFormInstance = actualFormEl[0]?.widget;
             actualFormInstance.formEl = cloneEl;
             forEach(actionsEl, (el: any) => {
                 if (el.widget && actualFormInstance) {
                     (el as any).widget.form = actualFormInstance;
                 }
             });
         });
       });
     });
  }

  // assigning form instance on the dynamically created formfields as it will miss this on recreation.
  assignFormInstance(fields: Array<JQuery<HTMLElement>>) {
    forEach(fields, (field: any) => {
      let isParent = $(field).closest('[wmform]').is(this.$element);
      if (isParent && (field as any).widget) {
        (field as any).widget.form = this;
      }
    });
  }

  getMarkupManager() {
    if (!this.markupManager) {
      this.markupManager = runtimeEventManager.getService('LiveWidgetMarkupManagerService')?.markupManagerService;
    }
    return this.markupManager;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.updateMode = true;
    this.parentNode = this.$element[0].parentNode;
    this.setLayoutConfig();
    this.showBtns = this.showButtons('footer');
  }

  setLayoutConfig(nv?: string) {
    let layoutConfig;
    if (nv) {
      this.captionposition = nv
    }
    layoutConfig = getFieldLayoutConfig(this.captionwidth, this.captionposition);
    this._widgetClass = layoutConfig.widgetCls;
    this._captionClass = layoutConfig.captionCls;
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height') {
      this.$element.css('overflow', 'auto');
      if(this.isLayoutDialog) {
        this.$element.css('height', 'unset');
      }  else{
        this.$element.css('height',nv)
      }
    }
  }

  setUpdateMode() {
    if (this.defaultmode && this.defaultmode === 'Edit') {
      this.updateMode = true;
    } else {
      this.updateMode = false;
    }
  }

  override onPropertyChange(key: string, nv: any, ov?: any) {
    switch (key) {
      case 'captionalign':
        this.captionAlignClass = 'align-' + nv;
        break;
      case 'captionposition':
        this.setLayoutConfig(nv);
        break;
      case 'captionwidth':
        this.setLayoutConfig();
        break;
      case 'captionsize':
        this.captionsize = nv;
        break;
      case 'formdata':
        console.log('formdata', nv);
        break;
      case 'formlayout':
      case 'defaultmode':
        this.setUpdateMode();
        break;
      case 'method':
        this.widgetProps['enctype'].show = nv === 'post';
        break;
      case 'dataset':
        // StudioMode result has to be applied by default to dataset.
        if (this.nativeElement.hasAttribute('wmLiveFilter')) {
          (this as any)['result'] = nv;
        }
        break;
      case 'itemsperrow': 
          setListClass(this);
        this.$element.attr('itemsperrow', nv);
        setTimeout(() => {
          $(this.nativeElement).find('div[data-role="form-field"], div[data-role="filter-field"]').removeClass(function (_, className) {
            // Remove only Bootstrap column classes (col-*)
            return (className.match(/\bcol-\S+/g) || []).join(' ');
          }).addClass(this.itemsPerRowClass);
        });
      break;
    }
    super.onPropertyChange(key, nv, ov);
    this.showBtns = this.showButtons('footer');
  }

  trackByFn(index: number, button: any): any {
    return button.key;
  }

  registerActions(formAction: any) {
    this.buttonArray.push(formAction);

    this.showBtns = this.showButtons('footer');
    this.cdr.detectChanges();
  }

  // Method to show/hide the panel header or footer based on the buttons
  showButtons(position: string) {
    return some(this.buttonArray, btn => {
      return includes(btn.position, position) && btn.updateMode.toString() === this.updateMode.toString();
    });
  }

  setFieldValue(field: any, data: any, innerFormdata?: any) {

  }

  registerFormWidget(widget: FormFieldDirective) {
    const name: string = get(widget, 'name') || get(widget, 'key') || '';
    if (name) {
      this.formWidgets[name] = widget;
    }
  }

  registerFormFields(formField: any) {
    const fieldCount = this.formFields.push(formField);
    this.formfields[formField.key] = formField;
    this.registerFormWidget(formField);
    // this._debouncedUpdateFieldSource();
    if (this.parentForm) {
      this.parentForm.formFields.push(formField);
      this.parentForm.formfields[formField.key] = formField;
      // inner formfields are pushed to parentForm, passing current innerForm's formdata to set innerFormdata to these innerFormFields
      // this.parentForm.setFormData(this.parentForm.formdata, this.formFields, this.formdata || {});
    }
    // // WMS-18967: Applying formadata after formfields are ready
    // if (fieldCount === this.numberOfFields && !_.isEmpty(this.formdata)) {
    //   this.onDataSourceChange();
    //   _.isArray(this.formdata) ? this.setFormData(_.last(this.formdata)) : this.setFormData(this.formdata);
    // }
  }

  clearData() {

  }

  // FormFields will contain all the fields in parent and inner form also.
  // This returns the formFields in the form based on the form name.
  getFormFields() {
    return filter(this.formFields, (formField: FormFieldDirective) => {
      return formField.form.name === this.name;
    });
  }

  getBindedVal(prop: string, nativeElement: any) {
    let propName = prop + '.bind';
    let val = nativeElement.getAttribute(propName);
    if (val && val !== 'null') {
      return ('bind:' + val);
    }
    return nativeElement.getAttribute(prop) || null;
  }
}
